import { get } from 'svelte/store';
import { storeBackendUrl, storeAccessToken } from '../store';
import { getCookie, setCookie } from '../common';
/**
 * Mise à jour du cookie "refresh_token"
 * Durée de validité 24h
 * @param value
 */
function setCookieRefreshToken(value) {
    setCookie("refresh_token", value, 24);
}
/**
 * Récupération du cookie "refresh_token"
 * Valeur "empty" par défaut
 * @returns
 */
function getCookieRefreshToken() {
    let cookieRefreshToken = "empty";
    if (getCookie("refresh_token") != null) {
        cookieRefreshToken = getCookie("refresh_token");
    }
    return cookieRefreshToken;
}
/**
 * Vérification de la validité de l'access_token
 * @returns
 */
async function checkAccessToken() {
    const apiUrl = get(storeBackendUrl) + "v1/infos/";
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(storeAccessToken));
    var myInit = {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache'
    };
    return fetch(apiUrl, myInit)
        .then(function (response) {
        if (response.status === 401) {
            return false;
        }
        else {
            return true;
        }
    })
        .then((data) => {
        return data;
    });
}
/**
 * Processus d'authentification à partir des tokens access et refresh
 * @returns
 */
export async function authentication() {
    const isChecked = await checkAccessToken();
    return new Promise((resolve, reject) => {
        if (isChecked) {
            resolve("");
        }
        else {
            const accessTokenUrl = get(storeBackendUrl) + "v1/token/";
            const refreshTokenUrl = get(storeBackendUrl) + "v1/token/refresh/";
            const _0x171e = ["\x73\x74\x72\x65\x73\x73", "\x74\x69\x73\x61\x6E\x65", "\x73\x74\x72\x69\x6E\x67\x69\x66\x79"];
            const toto = JSON[_0x171e[2]]({ zen: _0x171e[0], tea: _0x171e[1] });
            var initAccess = {
                method: 'POST',
                body: toto,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                mode: 'cors',
            };
            var myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", "Bearer " + getCookieRefreshToken());
            var initRefresh = {
                method: 'GET',
                headers: myHeaders,
                mode: 'cors',
                cache: 'no-cache'
            };
            return fetch(refreshTokenUrl, initRefresh)
                .then(function (response) {
                if (response.status === 401) {
                    throw new Error(response.status.toString());
                }
                else {
                    return response.json();
                }
            })
                .then(function (data_refresh) {
                storeAccessToken.set(data_refresh.access_token);
                resolve("ok");
            })
                .catch(function (error) {
                if (error.message === '401') {
                    fetch(accessTokenUrl, initAccess)
                        .then((response) => response.json())
                        .then(function (data_access) {
                        storeAccessToken.set(data_access.access_token);
                        setCookieRefreshToken(data_access.refresh_token);
                        resolve("ok");
                    });
                }
                else {
                    resolve("ko");
                    throw error;
                }
            });
        }
    });
}
